import { setupFormState } from '@/components/form/tidal-form'

import { FormData } from './types'

export const form = setupFormState<FormData>({
  id: 'orderForm',
  initialValues: {
    companyId: {
      status: 'mixed',
    },
    eligibility: {
      status: 'mixed',
    },
    forceVehicleId: {
      status: 'mixed',
    },
    priority: {
      status: 'mixed',
    },
    serviceTimeSec: {
      status: 'mixed',
    },
    timeWindows: {
      status: 'mixed',
    },
    email: {
      status: 'mixed',
    },
    phone: {
      status: 'mixed',
    },
    notes: {
      status: 'mixed',
    },
    location: {
      status: 'mixed',
    },
    type: {
      status: 'mixed',
    },
    tagsIn: {
      tags: {},
      remaining: 0,
      affectedOrdersCount: 0,
    },
    tagsOut: {
      tags: {},
      remaining: 0,
      affectedOrdersCount: 0,
    },
    loads: {
      exact: {},
      partial: {},
      affectedOrdersCount: 0,
      loadsDistribution: {},
    },
    recurrenceSettings: {
      status: 'mixed',
    },
  },
})
